import api from "../../../../../../../services/api";

// Discriminador usado na tabela genérica de Anexos para representar um tipo de
// equipamento personalizado (título + ícone), sem precisar de tabela própria
export const CUSTOM_EQUIPMENT_TYPE_ANEXO_TYPE = "equipamento_personalizado";

// Cache de blob URLs já resolvidas, evita rebaixar o mesmo ícone repetidamente
const iconUrlCache = new Map();

// Lista o catálogo global de tipos de equipamento personalizados (sem os bytes do ícone)
export const fetchCustomEquipmentTypes = async () => {
  const response = await api?.post?.("/anexos/findMany", {
    type: CUSTOM_EQUIPMENT_TYPE_ANEXO_TYPE,
  });
  return response?.data || [];
};

// Cria um novo tipo de equipamento personalizado (título + ícone) — multipart
export const createCustomEquipmentType = async ({ titulo, file } = {}) => {
  const formData = new FormData();
  formData.append("file", file, file?.name);
  formData.append("type", CUSTOM_EQUIPMENT_TYPE_ANEXO_TYPE);
  formData.append("descricao", titulo);
  const response = await api?.post?.("/anexos/createMultipart", formData);
  return response?.data;
};

// Edita título e/ou substitui o ícone de um tipo de equipamento personalizado existente.
// Só usa multipart quando troca o ícone (tem file); renomear sem trocar ícone continua
// no /anexos/update em JSON — não há bytes de arquivo envolvidos nesse caso.
export const updateCustomEquipmentType = async ({ id, titulo, file } = {}) => {
  let response;
  if (file) {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("file", file, file?.name);
    formData.append("descricao", titulo);
    response = await api?.post?.("/anexos/updateMultipart", formData);
  } else {
    response = await api?.post?.("/anexos/update", { id, descricao: titulo });
  }
  if (file) {
    // Ícone substituído: invalida a blob URL antiga em cache para forçar novo download
    // na próxima resolução — sem isso a lista continuaria exibindo o ícone anterior
    const cached = iconUrlCache.get(id);
    if (cached) URL.revokeObjectURL(cached);
    iconUrlCache.delete(id);
  }
  return response?.data;
};

// Remove um tipo de equipamento personalizado (hard delete, sem checagem de uso)
export const deleteCustomEquipmentType = async (id) => {
  await api?.post?.("/anexos/delete", { id });
  iconUrlCache.delete(id);
};

// Resolve (e cacheia) a blob URL do ícone de um tipo personalizado para exibição
export const resolveIconUrl = async (anexoId) => {
  if (!anexoId) return null;
  if (iconUrlCache.has(anexoId)) return iconUrlCache.get(anexoId);
  const response = await api?.post?.(
    "/anexos/download",
    { id: anexoId },
    { responseType: "blob" },
  );
  if (!response?.data) return null;
  const blobUrl = URL.createObjectURL(response.data);
  iconUrlCache.set(anexoId, blobUrl);
  return blobUrl;
};
